export class AppError {
    MessageId: string;
    constructor(public originalError?: any) { }
  
    Message: string | undefined;
}
